import { Button, Divider, Form, Input, Modal, message } from "antd";
import { useEffect } from "react";
import type { CategoryMessageDetail } from "../../types";

const { TextArea } = Input;

const MESSAGE_ATTRIBUTES = [
	{
		value: "BUILDING",
		label: "を入力すると、配信の時にイベント名に変換されます。",
	},
	{
		value: "NAME",
		label: "を入力すると、配信の時にお客様の名前に変換されます。",
	},
	{
		value: "DATE",
		label: "を入力すると、配信の時に予約の日付に変換されます。",
	},
	// {
	// 	value: "COMPANY-TEL",
	// 	label: "を入力すると、配信の時に問い合わせ電話番号に変換されます。",
	// },
];

interface EventMessageModalProps {
	isEventMessageModalVisible: boolean;
	hideEventMessageModal: () => void;
	currentCategoryMessageDetail: CategoryMessageDetail;
	onSubmit: (data: CategoryMessageDetail) => void;
}

export const EventMessageModal = (props: EventMessageModalProps) => {
	const {
		isEventMessageModalVisible,
		hideEventMessageModal,
		currentCategoryMessageDetail,
		onSubmit,
	} = props;

	const [eventMessageForm] = Form.useForm();

	useEffect(() => {
		if (!isEventMessageModalVisible) {
			eventMessageForm.resetFields();
		}
	}, [isEventMessageModalVisible, eventMessageForm]);

	useEffect(() => {
		if (isEventMessageModalVisible) {
			eventMessageForm.setFieldsValue({
				afterReservationMessage:
					currentCategoryMessageDetail?.afterReservationMessage,
				reminderMessageSevenDays:
					currentCategoryMessageDetail?.reminderMessageSevenDays,
				reminderMessageOneDay:
					currentCategoryMessageDetail?.reminderMessageOneDay,
				winners: currentCategoryMessageDetail?.winners,
			});
		}
	}, [
		isEventMessageModalVisible,
		currentCategoryMessageDetail,
		eventMessageForm,
	]);

	const handleEventMessage = (data: CategoryMessageDetail) => {
		onSubmit(data);
		hideEventMessageModal();
	};

	const handleCopyToClipboard = (attribute: string) => {
		navigator.clipboard.writeText(`[${attribute}]`);
		message.success(`[${attribute}]をコピーしました`);
	};

	const renderExtra = (attributes: typeof MESSAGE_ATTRIBUTES = []) => {
		return (
			<div className="flex flex-col">
				{attributes.map((attribute, key) => (
					<button
						key={key}
						type="button"
						onClick={() => handleCopyToClipboard(attribute.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								handleCopyToClipboard(attribute.value);
							}
						}}
						className="text-left w-full border-none bg-transparent p-0 cursor-pointer outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset rounded"
					>
						※メッセージに
						<span className="text-blue-500">[{attribute.value}]</span>
						{attribute.label}
					</button>
				))}
			</div>
		);
	};

	return (
		<Modal
			open={isEventMessageModalVisible}
			onCancel={hideEventMessageModal}
			title="お客様通知設定"
			footer={null}
			styles={{
				body: {
					maxHeight: "90vh",
					overflowY: "auto",
					overflowX: "hidden",
				},
			}}
			maskClosable={false}
			width={720}
			destroyOnClose
			centered
		>
			<Form
				form={eventMessageForm}
				layout="vertical"
				initialValues={{
					afterReservationMessage: undefined,
					reminderMessageSevenDays: undefined,
					reminderMessageOneDay: undefined,
				}}
				onFinish={handleEventMessage}
				size="large"
				requiredMark={false}
			>
				<div className="p-4 bg-yellow-100 rounded mb-8 border border-yellow-200">
					<p className="text-center m-0 text-yellow-800">
						設定されてない場合は、メッセージが配信されません。
					</p>
				</div>

				<Divider />

				<Form.Item
					name="afterReservationMessage"
					label="予約後に配信されるメッセージ"
					extra={renderExtra(MESSAGE_ATTRIBUTES)}
				>
					<TextArea
						placeholder="メッセージを入力してください"
						autoSize={{ minRows: 3 }}
					/>
				</Form.Item>

				<Divider />

				<Form.Item
					name="reminderMessageSevenDays"
					label="リマインドメッセージ（予約より7日前に配信される）"
					extra={renderExtra(MESSAGE_ATTRIBUTES)}
				>
					<TextArea
						placeholder="メッセージを入力してください"
						autoSize={{ minRows: 3 }}
					/>
				</Form.Item>

				<Divider />

				<Form.Item
					name="reminderMessageOneDay"
					label="リマインドメッセージ（予約より1日前に配信される）"
					extra={renderExtra(MESSAGE_ATTRIBUTES)}
				>
					<TextArea
						placeholder="メッセージを入力してください"
						autoSize={{ minRows: 3 }}
					/>
				</Form.Item>

				<Divider />

				<div className="flex justify-center">
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						className="m-1 w-32"
					>
						保存する
					</Button>
				</div>
			</Form>
		</Modal>
	);
};
